import { ClassCreate } from './ClassCreate';
import { ClassEdit } from './ClassEdit';
import { ClassList } from './ClassList';

export default {
    create: ClassCreate,
    edit: ClassEdit,
    list: ClassList
}
